import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { Graphics } from "@pixi/react";
import OverlayController, {
  OVERLAY_BACKGROUND_COLOR,
} from "./OverlayController.js";

const Overlay = forwardRef(
  (
    {
      dimensions,
      interactive = false,
      onPointerDown,
      name = "overlay",
      x = 0,
      y = 0,
      zIndex = 0,
      fadeDuration,
    },
    ref
  ) => {
    const overlayRef = useRef(null);
    const [backgroundAlpha, setBackgroundAlpha] = useState(0);

    // Create overlay controller instance
    const overlayControllerRef = useRef(null);
    if (!overlayControllerRef.current) {
      overlayControllerRef.current = new OverlayController(
        overlayRef,
        setBackgroundAlpha,
        fadeDuration
      );
    }

    // Expose overlay controller methods via ref
    useImperativeHandle(ref, () => ({
      fadeInBackground: (callback) =>
        overlayControllerRef.current.fadeInBackground(callback),
      fadeOutBackground: (callback) =>
        overlayControllerRef.current.fadeOutBackground(callback),
      // Allow direct alpha setting for instant visibility
      setAlpha: (alpha) => setBackgroundAlpha(alpha),
      // Also expose the graphics ref for direct access if needed
      graphics: overlayRef.current,
    }));

    return (
      <Graphics
        ref={overlayRef}
        name={name}
        x={x}
        y={y}
        zIndex={zIndex}
        draw={(g) => {
          g.clear();
          g.beginFill(OVERLAY_BACKGROUND_COLOR, 1);
          g.drawRect(0, 0, dimensions.width, dimensions.height);
          g.endFill();
        }}
        alpha={backgroundAlpha}
        eventMode={interactive ? "static" : "none"}
        pointerdown={onPointerDown}
        cursor={interactive && onPointerDown ? "pointer" : "default"}
      />
    );
  }
);

Overlay.displayName = "Overlay";

export default Overlay;
